module.exports = __webpack_public_path__ + "static/img/gt.3a895af8.png";